import { toast } from "react-toastify";
import { getTokenFromLocal, handleResponse } from "../../_helpers/handleResponseMiddleware";

let centralBaseUrl = process.env.REACT_APP_CENTRAL_BASE_URL;
let apiUrl = process.env.REACT_APP_CENTRAL_BASE_URL;

export function centralPDSDocDataService(params) {
  
    let user = getTokenFromLocal();
    let token = user ? user.access_token : null;
    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ...params }),
    };
    return fetch(
      `${centralBaseUrl}/getPDSDocData`,
      requestOptions
    )
      .then(handleResponse)
   .then(res => res)
      .catch(function (error) {
        console.log({error})
        toast.error(error.message)
      })
      .then(function (response) {
        // always executed
        return response ;
      });
  }

  export const CentralRevenueLossStatus = async (payload) => {
    let user = getTokenFromLocal();
    let token = user ? user.access_token : null;
  
    const requestOptions = {
        method: 'POST',
        headers: { 
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json' 
        },
        body: JSON.stringify(payload)
    };
  
    return fetch(`${apiUrl}/add-revenue-loss`, requestOptions)
        .then(handleResponse)
        .catch(error => {
            console.error('Error Revenue loss:', error);
            throw error;
        });
  };
